module.exports = __webpack_public_path__ + "img/cloud3.5bc78aea.png";